module.exports = __webpack_public_path__ + "fonts/Noto_Sans_JP-400-10.906b212.woff2";